import {CREATE_TEAMS_ERROR, CREATE_TEAMS_LOADING, CREATE_TEAMS_SUCCESS} from "../../../constant/actionTypes";

const createTeamReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_TEAMS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case CREATE_TEAMS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.teams,
            };
            return obj;
        }
        case CREATE_TEAMS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default createTeamReducer;